export function normalizePlatform(platform) {
  if (typeof platform !== 'string') return null;
  const value = platform.trim().toLowerCase();
  return value || null;
}

export function isSocialNotification(type) {
  return type === 'social_message' || type === 'social_comment';
}
